import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { ProfessionnelTirage } from 'src/app/professionnel/core/model/tirage/professionnel-tirage';
import { ProfessionnelTirageService } from 'src/app/professionnel/core/service/professionnel-tirage.service';
import { UpdateProfessionnelTirage } from 'src/app/professionnel/core/model/tirage/update-professionnel-tirage';

@Component({
  selector: 'app-edit-tirage',
  templateUrl: './edit-tirage.component.html',
  styleUrls: ['./edit-tirage.component.scss']
})
export class EditTirageComponent implements OnInit {

  
  @Input() professionnelTirageId;

  professionnelTirage: ProfessionnelTirage;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  updateProfessionnelTirage: UpdateProfessionnelTirage = new UpdateProfessionnelTirage;

  dateDebutJson: any;

  constructor(
    private _corporateTirageService: ProfessionnelTirageService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      montant: [null, Validators.compose([Validators.required])],
      dateTirage: [null, Validators.compose([Validators.required])],
      echeance: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.findById(this.professionnelTirageId);
  }

  findById(id) {
    this._corporateTirageService.findById(id).subscribe(
      (data) => {
        this.professionnelTirage = data;

        this.updateProfessionnelTirage.professionnelTirageId = this.professionnelTirage.id;
        this.updateProfessionnelTirage.echeance = this.professionnelTirage.echeance;
        this.updateProfessionnelTirage.montant = this.professionnelTirage.montant;
        this.dateDebutJson = this.convertDateStringToDateJson(
          this.professionnelTirage.dateTirage
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }

  save(): void {
    this.updateProfessionnelTirage.dateTirage =
      this.convertDateJsonToDateString(this.form2.value.dateTirage, {
        hour: 1,
        minute: 1,
      });

    this.spinner.show();
    this._corporateTirageService
      .update(this.updateProfessionnelTirage)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          this.errorMessage = error.error.message;
          console.log(error);
          this.spinner.hide();
        }
      );
  }

  convertDateStringToDateJson(date: string) {
    let dateSimple = new Date(date);
    let dateJson = {
      year: dateSimple.getFullYear(),
      month: dateSimple.getMonth() + 1,
      day: dateSimple.getDate(),
    };
    return dateJson;
  }

  convertDateJsonToDateString(date, time) {
    let month;
    month = date.month;
    if (date.month < 10) {
      month = "0" + date.month;
    }

    let day;
    day = date.day;
    if (date.day < 10) {
      day = "0" + date.day;
    }

    //

    let hour;
    hour = time.hour;
    if (time.hour < 10) {
      hour = "0" + time.hour;
    }

    let minute;
    minute = time.minute;
    if (time.minute < 10) {
      minute = "0" + time.minute;
    }

    let datetime =
      date.year +
      "-" +
      month +
      "-" +
      day +
      "T" +
      hour +
      ":" +
      minute +
      ":00.756Z";
    return datetime;
  }


}
